import * as React from 'react';
import { observer, inject } from 'mobx-react';
import _padStart from 'lodash-es/padStart';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./LeadRelations.css');

// Props
// tslint:disable-next-line:no-empty-interface
interface ILeadRelationsProps extends IAppOnlyStore {}

// Component
@inject('store')
@observer
export class LeadRelations extends React.Component<ILeadRelationsProps, {}> {
  public render() {
    const {
      lead: { openLeadDetails },
    } = this.props.store;

    if (!openLeadDetails || openLeadDetails.relations.length <= 0) {
      return null;
    }

    return (
      <ol className={s.list}>
        {openLeadDetails.relations.map((relation, relationIndex) => (
          <li key={relationIndex}>
            <h4>
              <span>
                {_padStart((relationIndex + 1).toString() + '.', 3, '0')}
              </span>
              <strong>{relation.name}</strong>
            </h4>
          </li>
        ))}
      </ol>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Relations/LeadRelations.tsx